<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="67.082"
    height="21.59"
    viewBox="0 0 67.082 21.59"
  >
    <g
      id="Сгруппировать_495"
      data-name="Сгруппировать 495"
      transform="translate(0 0)"
    >
      <path
        id="Контур_1135"
        data-name="Контур 1135"
        d="M-87.047,349.814l-8.779,20.925h-5.742l-4.307-16.729a2.309,2.309,0,0,0-1.27-1.822,21.784,21.784,0,0,0-5.356-1.767l.11-.607h9.22a2.523,2.523,0,0,1,2.485,2.153l2.264,12.091,5.632-14.245Zm22.471,14.079c0-5.521-7.619-5.852-7.564-8.282,0-.773.718-1.546,2.319-1.767a10.323,10.323,0,0,1,5.356.939l.939-4.417a14.123,14.123,0,0,0-5.08-.939c-5.356,0-9.11,2.871-9.165,6.9-.055,3.037,2.705,4.693,4.748,5.687s2.816,1.712,2.816,2.6c0,1.38-1.712,2.043-3.257,2.043a11.107,11.107,0,0,1-5.576-1.325l-.994,4.583a15.378,15.378,0,0,0,6.018,1.1c5.687.055,9.386-2.761,9.441-7.122m14.134,6.846h5.024l-4.362-20.925h-4.638a2.468,2.468,0,0,0-2.319,1.546l-8.171,19.379h5.687l1.1-3.147h6.957Zm-6.073-7.4,2.871-7.84,1.656,7.84Zm-22.8-13.527-4.472,20.925H-89.2l4.472-20.925Z"
        transform="translate(112.5 -349.427)"
      />
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'Icon',
  }
</script>
